import React from 'react';
import Hero from './sections/Hero';
import PoweredBy from './sections/PoweredBy';
import Stats from './sections/Stats';
import WhyUs from './sections/WhyUs';
import Team from './sections/Team';
import Security from './sections/Security';
import Loan from './sections/Loan';
import FAQ from './sections/FAQ';
import Footer from './sections/Footer';
import CTA from './sections/CTA';
import Header from './sections/Header';
import AnimatedPortfolio from "./pages/Testpage"
import TermAndCondition from "./pages/term&condition"


import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { DataProvider } from './contaxt/DataContect';
import ContactPage from './pages/contact';


function ReapCapital() {
  

  return (
    
    <div className="bg-[#FFFFFFF5
]  text-black min-h-screen relative overflow-hidden justify-center items-center">

      
      {/* Header */}
      <Header/>

      {/* Hero Section */}
      <Hero/>
      
      

      {/* Powered By Section */}
      <PoweredBy/>
      

      {/* Stats Section */}
      <Stats/>

      {/* Business Loans Section */}
      <Loan/>

      {/* Why Choose Section */}
      <WhyUs/>

      {/* Founders Section */}
      <Team/>

      {/* Security Section */}
      <Security/>
      {/* FAQ Section */}
      
        <FAQ/>
      {/* Final CTA Section */}
      <CTA/>

      {/* Footer */}
      <Footer />
    </div>
  );
}


const App = () => {

  return (
    <DataProvider>
    <Router>
        <Routes>
          <Route path="/" element={<ReapCapital/>} />
          <Route path="/contact" element={<ContactPage/>} />
          <Route path="/test" element={<AnimatedPortfolio/>} />
          <Route path="/terms-and-conditions" element={<TermAndCondition/>} />


  
         
        </Routes>
    </Router>
    </DataProvider>
        

  );
};

const RootApp = () => (
    <App />
);

export default RootApp;